import { mapDTO } from '@twistezo/ts-dto-mapper'
import { isNil } from 'lodash'

import { demandToAccount } from 'features/globalSetup/api/mappers/demandToAccount'
import { PrebidModuleDTO } from 'features/globalSetup/api/types/prebidModule'
import {
  PrebidModuleSlice,
  WorkspacePrebidModuleSlice,
} from 'features/globalSetup/contexts/PrebidModulesContext'
import { isPAAPIModule } from 'features/globalSetup/forms/Prebid/Modules/GeneralPaapiForm'
import { EditPaapiParamsSchema } from 'features/globalSetup/forms/Prebid/Modules/schemas/editPaapiSchema'
import { WorkspacePrebidModuleParameter } from 'features/globalSetup/types/workspacePrebidModule'
import { withoutOuterQuotes } from 'utils/string'
import { WorkspacePrebidModuleSliceDTO } from './types'

type From = WorkspacePrebidModuleSliceDTO
type PrebidModuleSliceDTO = Pick<PrebidModuleDTO, 'demand' | 'id' | 'name'>
type To = WorkspacePrebidModuleSlice

const prebidModuleSliceFromDTO = (
  prebidModuleSliceDTO: PrebidModuleSliceDTO,
): PrebidModuleSlice => {
  const { demand, id, name } = prebidModuleSliceDTO

  return {
    account: demandToAccount(demand),
    id: id,
    name: name,
  }
}

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((workspacePrebidModule: From): To => {
    const { enabled, id, params, prebidModule, status, workspaceBidderIds } = workspacePrebidModule

    let parameters
    if (isPAAPIModule(prebidModule.name)) {
      const { componentSeller, defaultForSlots, paapiForGpt, parallel } = params

      parameters = {
        componentSeller: isNil(componentSeller)
          ? ''
          : withoutOuterQuotes(JSON.stringify(componentSeller)),
        defaultForSlots: isNil(defaultForSlots) ? 1 : (defaultForSlots as number),
        paapiForGpt: isNil(paapiForGpt) ? true : (paapiForGpt as boolean),
        parallel: isNil(parallel) ? false : (parallel as boolean),
      } as EditPaapiParamsSchema
    } else {
      parameters = Object.entries(params).map(
        ([key, value]: [key: string, value: unknown]): WorkspacePrebidModuleParameter => {
          return {
            name: key,
            value: isNil(value) ? '' : withoutOuterQuotes(JSON.stringify(value)),
          }
        },
      )
    }

    return {
      enabled,
      id,
      parameters,
      prebidModule: prebidModuleSliceFromDTO(prebidModule),
      status,
      workspaceBidderIds,
    }
  })
